var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('div',{attrs:{"id":"header"}},[_c('img',{attrs:{"src":require("../assets/images/logo.png"),"alt":"logo"}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.eixt()}}},[_vm._v("退出")])]),_vm._v(" "),_c('div',{attrs:{"id":"body"}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa0a93a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 